/** 同步接口不等待异步值，但必须消费其拒绝，避免宿主 unhandledrejection。 */
export function consumeAsyncValue(value: unknown): boolean {
  if (value && typeof (value as any).then === 'function') {
    void Promise.resolve(value).catch(() => undefined);
    return true;
  }
  return false;
}
